<ng-template #infosTemplateHeader>
  <a routerLink="tickets">Gérer mes tickets</a>
</ng-template>
<ng-template #infosTemplateContent>
  @for (ticket of tickets; track ticket) {
    <a class="content-grid p-3" [title]="ticket.title" [routerLink]="['/tickets', ticket.number]">
      <div>
        <div>{{ ticket.title }}</div>
        <div class="fst-italic text-light-grey">Modifié le {{ ticket.changed | date:'dd/MM/yyyy à HH\'h\'mm' }}</div>
      </div>
      <app-badge [label]="getCategoryFromSlug(ticket.product)"></app-badge>
    </a>
  }
</ng-template>
<app-dash-block title="Derniers tickets mis à jour" [error]="error" [headerTemplate]="infosTemplateHeader"
  [contentTemplate]="tickets ? infosTemplateContent : null">
</app-dash-block>
